

module.exports = {
	firstName: '',
	mqttUsername: '',
	mqttPassword: '',
	// httpAuthKey: '',
	httpAuthKey1: '',
	httpAuthKey2: '',
	httpAuthKey3: '',
	defaultBoolAgg: 'live',
 	defaultNumAgg: 'agg_10s',
	defaultMessagingType: '',
	subscriptionStatus: 'unsubscribed',
	stripeSubscriptionStatus: null,
	userType: 'user',

	// ── SMS alerts ───────────────────────────────────────────────
	defaultAlertMobileNumber: '',	// the SMS phone number (E.164 once saved)
	smsEnabled: false,				// NEW — "Enable for SMS" checkbox state
	smsConsentAccepted: false,		// tracks whether user accepted the SMS policy
	smsConsentNumber: '',			// NEW — normalized number the consent applies to

	// ── WhatsApp alerts ──────────────────────────────────────────
	defaultAlertWhatsappNumber: '',	// NEW — the WhatsApp phone number (E.164 once saved)
	whatsappEnabled: false,			// NEW — "Enable for WhatsApp" checkbox state
	whatsappConsentAccepted: false,	// NEW — tracks whether user accepted the WhatsApp policy
	whatsappConsentNumber: '',		// NEW — normalized number the WhatsApp opt-in applies to

	defaultAlertEmail: '',
	// initialScreen: 'Controls',
	// initialTimeframe: 'snapshot'
};